// extracted by mini-css-extract-plugin
module.exports = {"sms-communication-consent":"SmsCommunicationConsent__sms-communication-consent___1aip3"};